var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"files-app-extra-settings"}},[_vm._l((_vm.settings),function(setting){return [_c('Setting',{key:setting.name,attrs:{"el":setting.el}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }